export { default, getStaticProps } from "app/seo/smartphones-reconditionnes/page";
